<template>
  <div>
    <el-card>
      <alter-form :customeButton="true" @handleAddFirstArray="afterAdd" :addFirstArray="true" :subFirstArray="true"
        @handleSubFirstArray="removeArray" :watchImageVisible="false" @handleChange="handleChange" ref="alterForm"
        @formSubmit="formSubmit" :modifyData="modifyData" :formData="formData" :collapseLength="collapseLength"
        @switchChanged="handleSwitchChange">
        <template v-slot:customeButton="data">
          <el-row type="flex" justify="center" style="margin-top: 10px">
            <el-button @click="handleCancelClick">{{ $t('button.cancel') }}</el-button>
            <el-button type="primary" @click="formSubmit(data)">{{ $t('button.confirm') }}</el-button>
          </el-row>
        </template>
      </alter-form>
    </el-card>
  </div>
</template>

<script>
import onlineCouponEdit from './index.js'
export default onlineCouponEdit
</script>

<style lang="scss" scope>@import './index.scss';</style>
